export var RequiredIndicator;
(function (RequiredIndicator) {
    /** Unknown required indicator. */
    RequiredIndicator["UNKNOWN_INDICATOR"] = "UNKNOWN_INDICATOR";
    /** Asterisk (*). */
    RequiredIndicator["ASTERISK"] = "ASTERISK";
    /** Text (default: "Required"). */
    RequiredIndicator["TEXT"] = "TEXT";
    /** None. */
    RequiredIndicator["NONE"] = "NONE";
})(RequiredIndicator || (RequiredIndicator = {}));
export var RequiredIndicatorPlacement;
(function (RequiredIndicatorPlacement) {
    /** Unknown required indicator placement. */
    RequiredIndicatorPlacement["UNKNOWN_PLACEMENT"] = "UNKNOWN_PLACEMENT";
    /** After field title. */
    RequiredIndicatorPlacement["AFTER_FIELD_TITLE"] = "AFTER_FIELD_TITLE";
    /** Before field title. */
    RequiredIndicatorPlacement["BEFORE_FIELD_TITLE"] = "BEFORE_FIELD_TITLE";
})(RequiredIndicatorPlacement || (RequiredIndicatorPlacement = {}));
export var Format;
(function (Format) {
    Format["UNDEFINED"] = "UNDEFINED";
    Format["DATE"] = "DATE";
    Format["TIME"] = "TIME";
    Format["DATE_TIME"] = "DATE_TIME";
    Format["EMAIL"] = "EMAIL";
    Format["URL"] = "URL";
    Format["UUID"] = "UUID";
    Format["PHONE"] = "PHONE";
    Format["URI"] = "URI";
    Format["HOSTNAME"] = "HOSTNAME";
    Format["COLOR_HEX"] = "COLOR_HEX";
    Format["CURRENCY"] = "CURRENCY";
    Format["LANGUAGE"] = "LANGUAGE";
    Format["DATE_OPTIONAL_TIME"] = "DATE_OPTIONAL_TIME";
})(Format || (Format = {}));
export var ValidationFormat;
(function (ValidationFormat) {
    ValidationFormat["UNDEFINED"] = "UNDEFINED";
    /** File upload validation. */
    ValidationFormat["WIX_FILE"] = "WIX_FILE";
    /** Payment validation. */
    ValidationFormat["PAYMENT"] = "PAYMENT";
    /** Multiline address. */
    ValidationFormat["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
    /** Scheduling validation. */
    ValidationFormat["SCHEDULING"] = "SCHEDULING";
})(ValidationFormat || (ValidationFormat = {}));
export var ProductType;
(function (ProductType) {
    /** Unknown product type. */
    ProductType["UNKNOWN"] = "UNKNOWN";
    /** Shippable (physical) product. */
    ProductType["SHIPPABLE"] = "SHIPPABLE";
    /** Digital product. */
    ProductType["DIGITAL"] = "DIGITAL";
})(ProductType || (ProductType = {}));
export var PriceType;
(function (PriceType) {
    /** Unknown price type. */
    PriceType["UNKNOWN"] = "UNKNOWN";
    /** Fixed price. */
    PriceType["FIXED_PRICE"] = "FIXED_PRICE";
    /** Dynamic price from price range. */
    PriceType["DYNAMIC_PRICE"] = "DYNAMIC_PRICE";
})(PriceType || (PriceType = {}));
export var FormatEnumFormat;
(function (FormatEnumFormat) {
    FormatEnumFormat["UNKNOWN_FORMAT"] = "UNKNOWN_FORMAT";
    FormatEnumFormat["DATE"] = "DATE";
    FormatEnumFormat["TIME"] = "TIME";
    FormatEnumFormat["DATE_TIME"] = "DATE_TIME";
    FormatEnumFormat["EMAIL"] = "EMAIL";
    FormatEnumFormat["URL"] = "URL";
    FormatEnumFormat["UUID"] = "UUID";
    FormatEnumFormat["PHONE"] = "PHONE";
    FormatEnumFormat["URI"] = "URI";
    FormatEnumFormat["HOSTNAME"] = "HOSTNAME";
    FormatEnumFormat["COLOR_HEX"] = "COLOR_HEX";
    FormatEnumFormat["CURRENCY"] = "CURRENCY";
    FormatEnumFormat["LANGUAGE"] = "LANGUAGE";
    FormatEnumFormat["DATE_OPTIONAL_TIME"] = "DATE_OPTIONAL_TIME";
})(FormatEnumFormat || (FormatEnumFormat = {}));
export var StringComponentType;
(function (StringComponentType) {
    StringComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    StringComponentType["TEXT_INPUT"] = "TEXT_INPUT";
    StringComponentType["RADIO_GROUP"] = "RADIO_GROUP";
    StringComponentType["DROPDOWN"] = "DROPDOWN";
    StringComponentType["DATE_TIME"] = "DATE_TIME";
    StringComponentType["PHONE_INPUT"] = "PHONE_INPUT";
    StringComponentType["DATE_INPUT"] = "DATE_INPUT";
    StringComponentType["TIME_INPUT"] = "TIME_INPUT";
    StringComponentType["DATE_PICKER"] = "DATE_PICKER";
})(StringComponentType || (StringComponentType = {}));
export var NodeType;
(function (NodeType) {
    NodeType["PARAGRAPH"] = "PARAGRAPH";
    NodeType["TEXT"] = "TEXT";
    NodeType["HEADING"] = "HEADING";
    NodeType["BULLETED_LIST"] = "BULLETED_LIST";
    NodeType["ORDERED_LIST"] = "ORDERED_LIST";
    NodeType["LIST_ITEM"] = "LIST_ITEM";
    NodeType["BLOCKQUOTE"] = "BLOCKQUOTE";
    NodeType["CODE_BLOCK"] = "CODE_BLOCK";
    NodeType["VIDEO"] = "VIDEO";
    NodeType["DIVIDER"] = "DIVIDER";
    NodeType["FILE"] = "FILE";
    NodeType["GALLERY"] = "GALLERY";
    NodeType["GIF"] = "GIF";
    NodeType["HTML"] = "HTML";
    NodeType["IMAGE"] = "IMAGE";
    NodeType["LINK_PREVIEW"] = "LINK_PREVIEW";
    /** @deprecated */
    NodeType["MAP"] = "MAP";
    NodeType["POLL"] = "POLL";
    NodeType["APP_EMBED"] = "APP_EMBED";
    NodeType["BUTTON"] = "BUTTON";
    NodeType["COLLAPSIBLE_LIST"] = "COLLAPSIBLE_LIST";
    NodeType["TABLE"] = "TABLE";
    NodeType["EMBED"] = "EMBED";
    NodeType["COLLAPSIBLE_ITEM"] = "COLLAPSIBLE_ITEM";
    NodeType["COLLAPSIBLE_ITEM_TITLE"] = "COLLAPSIBLE_ITEM_TITLE";
    NodeType["COLLAPSIBLE_ITEM_BODY"] = "COLLAPSIBLE_ITEM_BODY";
    NodeType["TABLE_CELL"] = "TABLE_CELL";
    NodeType["TABLE_ROW"] = "TABLE_ROW";
    NodeType["EXTERNAL"] = "EXTERNAL";
    NodeType["AUDIO"] = "AUDIO";
    NodeType["CAPTION"] = "CAPTION";
    NodeType["LAYOUT"] = "LAYOUT";
    NodeType["LAYOUT_CELL"] = "LAYOUT_CELL";
})(NodeType || (NodeType = {}));
export var WidthType;
(function (WidthType) {
    /** Width matches the content width */
    WidthType["CONTENT"] = "CONTENT";
    /** Small Width */
    WidthType["SMALL"] = "SMALL";
    /** Width will match the original asset width */
    WidthType["ORIGINAL"] = "ORIGINAL";
    /** coast-to-coast display */
    WidthType["FULL_WIDTH"] = "FULL_WIDTH";
})(WidthType || (WidthType = {}));
export var PluginContainerDataAlignment;
(function (PluginContainerDataAlignment) {
    /** Center Alignment */
    PluginContainerDataAlignment["CENTER"] = "CENTER";
    /** Left Alignment */
    PluginContainerDataAlignment["LEFT"] = "LEFT";
    /** Right Alignment */
    PluginContainerDataAlignment["RIGHT"] = "RIGHT";
})(PluginContainerDataAlignment || (PluginContainerDataAlignment = {}));
export var Type;
(function (Type) {
    /** Regular link button */
    Type["LINK"] = "LINK";
    /** Triggers custom action that is defined in plugin configuration by the consumer */
    Type["ACTION"] = "ACTION";
})(Type || (Type = {}));
export var Target;
(function (Target) {
    /** Opens the linked document in the same frame as it was clicked (this is default) */
    Target["SELF"] = "SELF";
    /** Opens the linked document in a new window or tab */
    Target["BLANK"] = "BLANK";
    /** Opens the linked document in the parent frame */
    Target["PARENT"] = "PARENT";
    /** Opens the linked document in the full body of the window */
    Target["TOP"] = "TOP";
})(Target || (Target = {}));
export var TextAlignment;
(function (TextAlignment) {
    /** browser default, eqivalent to `initial` */
    TextAlignment["AUTO"] = "AUTO";
    /** Left align */
    TextAlignment["LEFT"] = "LEFT";
    /** Right align */
    TextAlignment["RIGHT"] = "RIGHT";
    /** Center align */
    TextAlignment["CENTER"] = "CENTER";
    /** Text is spaced to line up its left and right edges to the left and right edges of the line box, except for the last line */
    TextAlignment["JUSTIFY"] = "JUSTIFY";
})(TextAlignment || (TextAlignment = {}));
export var LineStyle;
(function (LineStyle) {
    /** Single Line */
    LineStyle["SINGLE"] = "SINGLE";
    /** Double Line */
    LineStyle["DOUBLE"] = "DOUBLE";
    /** Dashed Line */
    LineStyle["DASHED"] = "DASHED";
    /** Dotted Line */
    LineStyle["DOTTED"] = "DOTTED";
})(LineStyle || (LineStyle = {}));
export var Width;
(function (Width) {
    /** Large line */
    Width["LARGE"] = "LARGE";
    /** Medium line */
    Width["MEDIUM"] = "MEDIUM";
    /** Small line */
    Width["SMALL"] = "SMALL";
})(Width || (Width = {}));
export var Alignment;
(function (Alignment) {
    /** Center alignment */
    Alignment["CENTER"] = "CENTER";
    /** Left alignment */
    Alignment["LEFT"] = "LEFT";
    /** Right alignment */
    Alignment["RIGHT"] = "RIGHT";
})(Alignment || (Alignment = {}));
export var ViewMode;
(function (ViewMode) {
    /** No PDF view */
    ViewMode["NONE"] = "NONE";
    /** Full PDF view */
    ViewMode["FULL"] = "FULL";
    /** Mini PDF view */
    ViewMode["MINI"] = "MINI";
})(ViewMode || (ViewMode = {}));
export var LayoutType;
(function (LayoutType) {
    /** Collage type */
    LayoutType["COLLAGE"] = "COLLAGE";
    /** Masonry type */
    LayoutType["MASONRY"] = "MASONRY";
    /** Grid type */
    LayoutType["GRID"] = "GRID";
    /** Thumbnail type */
    LayoutType["THUMBNAIL"] = "THUMBNAIL";
    /** Slider type */
    LayoutType["SLIDER"] = "SLIDER";
    /** Slideshow type */
    LayoutType["SLIDESHOW"] = "SLIDESHOW";
    /** Panorama type */
    LayoutType["PANORAMA"] = "PANORAMA";
    /** Column type */
    LayoutType["COLUMN"] = "COLUMN";
    /** Magic type */
    LayoutType["MAGIC"] = "MAGIC";
    /** Fullsize images type */
    LayoutType["FULLSIZE"] = "FULLSIZE";
})(LayoutType || (LayoutType = {}));
export var Orientation;
(function (Orientation) {
    /** Rows Orientation */
    Orientation["ROWS"] = "ROWS";
    /** Columns Orientation */
    Orientation["COLUMNS"] = "COLUMNS";
})(Orientation || (Orientation = {}));
export var Crop;
(function (Crop) {
    /** Crop to fill */
    Crop["FILL"] = "FILL";
    /** Crop to fit */
    Crop["FIT"] = "FIT";
})(Crop || (Crop = {}));
export var ThumbnailsAlignment;
(function (ThumbnailsAlignment) {
    /** Top alignment */
    ThumbnailsAlignment["TOP"] = "TOP";
    /** Right alignment */
    ThumbnailsAlignment["RIGHT"] = "RIGHT";
    /** Bottom alignment */
    ThumbnailsAlignment["BOTTOM"] = "BOTTOM";
    /** Left alignment */
    ThumbnailsAlignment["LEFT"] = "LEFT";
    /** No thumbnail */
    ThumbnailsAlignment["NONE"] = "NONE";
})(ThumbnailsAlignment || (ThumbnailsAlignment = {}));
export var GIFType;
(function (GIFType) {
    GIFType["NORMAL"] = "NORMAL";
    GIFType["STICKER"] = "STICKER";
})(GIFType || (GIFType = {}));
export var Source;
(function (Source) {
    Source["HTML"] = "HTML";
    Source["ADSENSE"] = "ADSENSE";
})(Source || (Source = {}));
export var Position;
(function (Position) {
    /** Thumbnail positioned at the start (left in LTR layouts, right in RTL layouts) */
    Position["START"] = "START";
    /** Thumbnail positioned at the end (right in LTR layouts, left in RTL layouts) */
    Position["END"] = "END";
    /** Thumbnail positioned at the top */
    Position["TOP"] = "TOP";
    /** Thumbnail hidden and not displayed */
    Position["HIDDEN"] = "HIDDEN";
})(Position || (Position = {}));
export var MapType;
(function (MapType) {
    /** Roadmap map type */
    MapType["ROADMAP"] = "ROADMAP";
    /** Satellite map type */
    MapType["SATELITE"] = "SATELITE";
    /** Hybrid map type */
    MapType["HYBRID"] = "HYBRID";
    /** Terrain map type */
    MapType["TERRAIN"] = "TERRAIN";
})(MapType || (MapType = {}));
export var ViewRole;
(function (ViewRole) {
    /** Only Poll creator can view the results */
    ViewRole["CREATOR"] = "CREATOR";
    /** Anyone who voted can see the results */
    ViewRole["VOTERS"] = "VOTERS";
    /** Anyone can see the results, even if one didn't vote */
    ViewRole["EVERYONE"] = "EVERYONE";
})(ViewRole || (ViewRole = {}));
export var VoteRole;
(function (VoteRole) {
    /** Logged in member */
    VoteRole["SITE_MEMBERS"] = "SITE_MEMBERS";
    /** Anyone */
    VoteRole["ALL"] = "ALL";
})(VoteRole || (VoteRole = {}));
export var PollLayoutType;
(function (PollLayoutType) {
    /** List */
    PollLayoutType["LIST"] = "LIST";
    /** Grid */
    PollLayoutType["GRID"] = "GRID";
})(PollLayoutType || (PollLayoutType = {}));
export var PollLayoutDirection;
(function (PollLayoutDirection) {
    /** Left-to-right */
    PollLayoutDirection["LTR"] = "LTR";
    /** Right-to-left */
    PollLayoutDirection["RTL"] = "RTL";
})(PollLayoutDirection || (PollLayoutDirection = {}));
export var BackgroundType;
(function (BackgroundType) {
    /** Color background type */
    BackgroundType["COLOR"] = "COLOR";
    /** Image background type */
    BackgroundType["IMAGE"] = "IMAGE";
    /** Gradiant background type */
    BackgroundType["GRADIENT"] = "GRADIENT";
})(BackgroundType || (BackgroundType = {}));
export var DecorationType;
(function (DecorationType) {
    DecorationType["BOLD"] = "BOLD";
    DecorationType["ITALIC"] = "ITALIC";
    DecorationType["UNDERLINE"] = "UNDERLINE";
    DecorationType["SPOILER"] = "SPOILER";
    DecorationType["ANCHOR"] = "ANCHOR";
    DecorationType["MENTION"] = "MENTION";
    DecorationType["LINK"] = "LINK";
    DecorationType["COLOR"] = "COLOR";
    DecorationType["FONT_SIZE"] = "FONT_SIZE";
    DecorationType["EXTERNAL"] = "EXTERNAL";
})(DecorationType || (DecorationType = {}));
export var FontType;
(function (FontType) {
    FontType["PX"] = "PX";
    FontType["EM"] = "EM";
})(FontType || (FontType = {}));
export var AppType;
(function (AppType) {
    AppType["PRODUCT"] = "PRODUCT";
    AppType["EVENT"] = "EVENT";
    AppType["BOOKING"] = "BOOKING";
})(AppType || (AppType = {}));
export var InitialExpandedItems;
(function (InitialExpandedItems) {
    /** First item will be expended initally */
    InitialExpandedItems["FIRST"] = "FIRST";
    /** All items will expended initally */
    InitialExpandedItems["ALL"] = "ALL";
    /** All items collapsed initally */
    InitialExpandedItems["NONE"] = "NONE";
})(InitialExpandedItems || (InitialExpandedItems = {}));
export var Direction;
(function (Direction) {
    /** Left-to-right */
    Direction["LTR"] = "LTR";
    /** Right-to-left */
    Direction["RTL"] = "RTL";
})(Direction || (Direction = {}));
export var VerticalAlignment;
(function (VerticalAlignment) {
    /** Top alignment */
    VerticalAlignment["TOP"] = "TOP";
    /** Middle alignment */
    VerticalAlignment["MIDDLE"] = "MIDDLE";
    /** Bottom alignment */
    VerticalAlignment["BOTTOM"] = "BOTTOM";
})(VerticalAlignment || (VerticalAlignment = {}));
/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 * The JSON representation for `NullValue` is JSON `null`.
 */
export var NullValue;
(function (NullValue) {
    /** Null value. */
    NullValue["NULL_VALUE"] = "NULL_VALUE";
})(NullValue || (NullValue = {}));
export var NumberOfColumns;
(function (NumberOfColumns) {
    /** Undefined number of columns. */
    NumberOfColumns["UNKNOWN"] = "UNKNOWN";
    /** Zero columns. */
    NumberOfColumns["ZERO"] = "ZERO";
    /** One column. */
    NumberOfColumns["ONE"] = "ONE";
    /** Two columns. */
    NumberOfColumns["TWO"] = "TWO";
    /** Three columns. */
    NumberOfColumns["THREE"] = "THREE";
})(NumberOfColumns || (NumberOfColumns = {}));
export var FirstDayOfWeekEnumFirstDayOfWeek;
(function (FirstDayOfWeekEnumFirstDayOfWeek) {
    /** First day of the week is Monday. */
    FirstDayOfWeekEnumFirstDayOfWeek["MONDAY"] = "MONDAY";
    /** First day of the week is Sunday. */
    FirstDayOfWeekEnumFirstDayOfWeek["SUNDAY"] = "SUNDAY";
})(FirstDayOfWeekEnumFirstDayOfWeek || (FirstDayOfWeekEnumFirstDayOfWeek = {}));
export var NumberComponentType;
(function (NumberComponentType) {
    NumberComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    NumberComponentType["NUMBER_INPUT"] = "NUMBER_INPUT";
    NumberComponentType["RATING_INPUT"] = "RATING_INPUT";
})(NumberComponentType || (NumberComponentType = {}));
export var BooleanComponentType;
(function (BooleanComponentType) {
    BooleanComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    BooleanComponentType["CHECKBOX"] = "CHECKBOX";
})(BooleanComponentType || (BooleanComponentType = {}));
export var ItemType;
(function (ItemType) {
    ItemType["UNKNOWN_ITEM_TYPE"] = "UNKNOWN_ITEM_TYPE";
    ItemType["STRING"] = "STRING";
    ItemType["NUMBER"] = "NUMBER";
    ItemType["BOOLEAN"] = "BOOLEAN";
    ItemType["INTEGER"] = "INTEGER";
    ItemType["OBJECT"] = "OBJECT";
})(ItemType || (ItemType = {}));
export var PropertiesTypeEnum;
(function (PropertiesTypeEnum) {
    PropertiesTypeEnum["UNKNOWN_PROPERTIES_TYPE"] = "UNKNOWN_PROPERTIES_TYPE";
    PropertiesTypeEnum["STRING"] = "STRING";
    PropertiesTypeEnum["NUMBER"] = "NUMBER";
    PropertiesTypeEnum["BOOLEAN"] = "BOOLEAN";
    PropertiesTypeEnum["INTEGER"] = "INTEGER";
    PropertiesTypeEnum["ARRAY"] = "ARRAY";
})(PropertiesTypeEnum || (PropertiesTypeEnum = {}));
export var ComponentType;
(function (ComponentType) {
    ComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    ComponentType["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
    ComponentType["TAGS"] = "TAGS";
})(ComponentType || (ComponentType = {}));
export var WixFileComponentType;
(function (WixFileComponentType) {
    WixFileComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    WixFileComponentType["FILE_UPLOAD"] = "FILE_UPLOAD";
    WixFileComponentType["SIGNATURE"] = "SIGNATURE";
})(WixFileComponentType || (WixFileComponentType = {}));
export var UploadFileFormat;
(function (UploadFileFormat) {
    /** Undefined upload file format. */
    UploadFileFormat["UNDEFINED"] = "UNDEFINED";
    /** Video files. */
    UploadFileFormat["VIDEO"] = "VIDEO";
    /** Image files. */
    UploadFileFormat["IMAGE"] = "IMAGE";
    /** Audio files. */
    UploadFileFormat["AUDIO"] = "AUDIO";
    /** Document files. */
    UploadFileFormat["DOCUMENT"] = "DOCUMENT";
    /** Archive files. */
    UploadFileFormat["ARCHIVE"] = "ARCHIVE";
})(UploadFileFormat || (UploadFileFormat = {}));
export var PaymentComponentType;
(function (PaymentComponentType) {
    PaymentComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    PaymentComponentType["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
    PaymentComponentType["DONATION_INPUT"] = "DONATION_INPUT";
    PaymentComponentType["PAYMENT_INPUT"] = "PAYMENT_INPUT";
    PaymentComponentType["FIXED_PAYMENT"] = "FIXED_PAYMENT";
})(PaymentComponentType || (PaymentComponentType = {}));
export var ImageFit;
(function (ImageFit) {
    ImageFit["UNKNOWN_IMAGE_FIT"] = "UNKNOWN_IMAGE_FIT";
    /** Image is scaled to maintain its aspect ratio while filling the element's entire content box. Portions of the image may be clipped if the aspect ratios do not match. */
    ImageFit["COVER"] = "COVER";
    /** Image is resized to fill the element's content box. Aspect ratio may not be preserved. */
    ImageFit["CONTAIN"] = "CONTAIN";
})(ImageFit || (ImageFit = {}));
export var SchedulingComponentType;
(function (SchedulingComponentType) {
    SchedulingComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    SchedulingComponentType["APPOINTMENT"] = "APPOINTMENT";
})(SchedulingComponentType || (SchedulingComponentType = {}));
export var AppointmentFormat;
(function (AppointmentFormat) {
    AppointmentFormat["UNKNOWN_FORMAT_TYPE"] = "UNKNOWN_FORMAT_TYPE";
    AppointmentFormat["IN_PERSON"] = "IN_PERSON";
    AppointmentFormat["VIDEO_CONFERENCE"] = "VIDEO_CONFERENCE";
    AppointmentFormat["PHONE"] = "PHONE";
})(AppointmentFormat || (AppointmentFormat = {}));
export var MultilineAddressComponentType;
(function (MultilineAddressComponentType) {
    MultilineAddressComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    MultilineAddressComponentType["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
})(MultilineAddressComponentType || (MultilineAddressComponentType = {}));
export var DefaultCountryConfigType;
(function (DefaultCountryConfigType) {
    /** Unknown default country config type. */
    DefaultCountryConfigType["UNKNOWN_DEFAULT_COUNTRY"] = "UNKNOWN_DEFAULT_COUNTRY";
    /** Country is determined by customer's IP address. */
    DefaultCountryConfigType["BY_IP"] = "BY_IP";
    /** Pre-selected default country. */
    DefaultCountryConfigType["COUNTRY"] = "COUNTRY";
})(DefaultCountryConfigType || (DefaultCountryConfigType = {}));
export var InputType;
(function (InputType) {
    InputType["UNKNOWN_INPUT_TYPE"] = "UNKNOWN_INPUT_TYPE";
    InputType["STRING"] = "STRING";
    InputType["NUMBER"] = "NUMBER";
    InputType["BOOLEAN"] = "BOOLEAN";
    InputType["ARRAY"] = "ARRAY";
    InputType["OBJECT"] = "OBJECT";
    InputType["WIX_FILE"] = "WIX_FILE";
    InputType["PAYMENT"] = "PAYMENT";
    InputType["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
    InputType["SCHEDULING"] = "SCHEDULING";
})(InputType || (InputType = {}));
export var EmailInfoTag;
(function (EmailInfoTag) {
    EmailInfoTag["UNTAGGED"] = "UNTAGGED";
    EmailInfoTag["MAIN"] = "MAIN";
})(EmailInfoTag || (EmailInfoTag = {}));
export var PhoneInfoTag;
(function (PhoneInfoTag) {
    PhoneInfoTag["UNTAGGED"] = "UNTAGGED";
    PhoneInfoTag["MAIN"] = "MAIN";
})(PhoneInfoTag || (PhoneInfoTag = {}));
export var Tag;
(function (Tag) {
    Tag["UNTAGGED"] = "UNTAGGED";
    Tag["HOME"] = "HOME";
})(Tag || (Tag = {}));
export var OptInLevel;
(function (OptInLevel) {
    OptInLevel["UNKNOWN"] = "UNKNOWN";
    OptInLevel["SINGLE_CONFIRMATION"] = "SINGLE_CONFIRMATION";
    OptInLevel["DOUBLE_CONFIRMATION"] = "DOUBLE_CONFIRMATION";
})(OptInLevel || (OptInLevel = {}));
export var ContactField;
(function (ContactField) {
    ContactField["UNDEFINED"] = "UNDEFINED";
    ContactField["FIRST_NAME"] = "FIRST_NAME";
    ContactField["LAST_NAME"] = "LAST_NAME";
    ContactField["COMPANY"] = "COMPANY";
    ContactField["POSITION"] = "POSITION";
    ContactField["EMAIL"] = "EMAIL";
    ContactField["PHONE"] = "PHONE";
    ContactField["ADDRESS"] = "ADDRESS";
    ContactField["BIRTHDATE"] = "BIRTHDATE";
    ContactField["CUSTOM_FIELD"] = "CUSTOM_FIELD";
    ContactField["SUBSCRIPTION"] = "SUBSCRIPTION";
    ContactField["VAT_ID"] = "VAT_ID";
})(ContactField || (ContactField = {}));
export var FieldType;
(function (FieldType) {
    FieldType["UNKNOWN_FIELD_TYPE"] = "UNKNOWN_FIELD_TYPE";
    FieldType["INPUT"] = "INPUT";
    FieldType["DISPLAY"] = "DISPLAY";
})(FieldType || (FieldType = {}));
export var DisplayFieldType;
(function (DisplayFieldType) {
    DisplayFieldType["UNKNOWN_FIELD_TYPE"] = "UNKNOWN_FIELD_TYPE";
    DisplayFieldType["RICH_CONTENT"] = "RICH_CONTENT";
    DisplayFieldType["PAGE_NAVIGATION"] = "PAGE_NAVIGATION";
})(DisplayFieldType || (DisplayFieldType = {}));
export var FieldFieldType;
(function (FieldFieldType) {
    FieldFieldType["UNKNOWN_FIELD_TYPE"] = "UNKNOWN_FIELD_TYPE";
    FieldFieldType["INPUT"] = "INPUT";
    FieldFieldType["DISPLAY"] = "DISPLAY";
})(FieldFieldType || (FieldFieldType = {}));
export var StringTypeFormatEnumFormat;
(function (StringTypeFormatEnumFormat) {
    StringTypeFormatEnumFormat["UNKNOWN_FORMAT"] = "UNKNOWN_FORMAT";
    StringTypeFormatEnumFormat["DATE"] = "DATE";
    StringTypeFormatEnumFormat["TIME"] = "TIME";
    StringTypeFormatEnumFormat["DATE_TIME"] = "DATE_TIME";
    StringTypeFormatEnumFormat["EMAIL"] = "EMAIL";
    StringTypeFormatEnumFormat["URL"] = "URL";
    StringTypeFormatEnumFormat["UUID"] = "UUID";
    StringTypeFormatEnumFormat["PHONE"] = "PHONE";
    StringTypeFormatEnumFormat["URI"] = "URI";
    StringTypeFormatEnumFormat["HOSTNAME"] = "HOSTNAME";
    StringTypeFormatEnumFormat["COLOR_HEX"] = "COLOR_HEX";
    StringTypeFormatEnumFormat["CURRENCY"] = "CURRENCY";
    StringTypeFormatEnumFormat["LANGUAGE"] = "LANGUAGE";
    StringTypeFormatEnumFormat["DATE_OPTIONAL_TIME"] = "DATE_OPTIONAL_TIME";
})(StringTypeFormatEnumFormat || (StringTypeFormatEnumFormat = {}));
export var InputFieldStringComponentType;
(function (InputFieldStringComponentType) {
    InputFieldStringComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    InputFieldStringComponentType["TEXT_INPUT"] = "TEXT_INPUT";
    InputFieldStringComponentType["RADIO_GROUP"] = "RADIO_GROUP";
    InputFieldStringComponentType["DROPDOWN"] = "DROPDOWN";
    InputFieldStringComponentType["DATE_TIME"] = "DATE_TIME";
    InputFieldStringComponentType["PHONE_INPUT"] = "PHONE_INPUT";
    InputFieldStringComponentType["DATE_INPUT"] = "DATE_INPUT";
    InputFieldStringComponentType["TIME_INPUT"] = "TIME_INPUT";
    InputFieldStringComponentType["DATE_PICKER"] = "DATE_PICKER";
})(InputFieldStringComponentType || (InputFieldStringComponentType = {}));
export var InputFieldNumberComponentType;
(function (InputFieldNumberComponentType) {
    InputFieldNumberComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    InputFieldNumberComponentType["NUMBER_INPUT"] = "NUMBER_INPUT";
    InputFieldNumberComponentType["RATING_INPUT"] = "RATING_INPUT";
})(InputFieldNumberComponentType || (InputFieldNumberComponentType = {}));
export var InputFieldBooleanComponentType;
(function (InputFieldBooleanComponentType) {
    InputFieldBooleanComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    InputFieldBooleanComponentType["CHECKBOX"] = "CHECKBOX";
})(InputFieldBooleanComponentType || (InputFieldBooleanComponentType = {}));
export var ArrayItemsItemType;
(function (ArrayItemsItemType) {
    ArrayItemsItemType["UNKNOWN_ITEM_TYPE"] = "UNKNOWN_ITEM_TYPE";
    ArrayItemsItemType["STRING"] = "STRING";
    ArrayItemsItemType["NUMBER"] = "NUMBER";
    ArrayItemsItemType["BOOLEAN"] = "BOOLEAN";
    ArrayItemsItemType["INTEGER"] = "INTEGER";
    ArrayItemsItemType["OBJECT"] = "OBJECT";
})(ArrayItemsItemType || (ArrayItemsItemType = {}));
export var PropertiesTypePropertiesTypeEnum;
(function (PropertiesTypePropertiesTypeEnum) {
    PropertiesTypePropertiesTypeEnum["UNKNOWN_PROPERTY_TYPE"] = "UNKNOWN_PROPERTY_TYPE";
    PropertiesTypePropertiesTypeEnum["STRING"] = "STRING";
    PropertiesTypePropertiesTypeEnum["NUMBER"] = "NUMBER";
    PropertiesTypePropertiesTypeEnum["BOOLEAN"] = "BOOLEAN";
    PropertiesTypePropertiesTypeEnum["INTEGER"] = "INTEGER";
    PropertiesTypePropertiesTypeEnum["ARRAY"] = "ARRAY";
})(PropertiesTypePropertiesTypeEnum || (PropertiesTypePropertiesTypeEnum = {}));
export var ArrayComponentType;
(function (ArrayComponentType) {
    ArrayComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    ArrayComponentType["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
    ArrayComponentType["TAGS"] = "TAGS";
})(ArrayComponentType || (ArrayComponentType = {}));
export var InputFieldWixFileComponentType;
(function (InputFieldWixFileComponentType) {
    InputFieldWixFileComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    InputFieldWixFileComponentType["FILE_UPLOAD"] = "FILE_UPLOAD";
    InputFieldWixFileComponentType["SIGNATURE"] = "SIGNATURE";
})(InputFieldWixFileComponentType || (InputFieldWixFileComponentType = {}));
export var InputFieldPaymentComponentType;
(function (InputFieldPaymentComponentType) {
    InputFieldPaymentComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    InputFieldPaymentComponentType["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
    InputFieldPaymentComponentType["DONATION_INPUT"] = "DONATION_INPUT";
    InputFieldPaymentComponentType["PAYMENT_INPUT"] = "PAYMENT_INPUT";
    InputFieldPaymentComponentType["FIXED_PAYMENT"] = "FIXED_PAYMENT";
})(InputFieldPaymentComponentType || (InputFieldPaymentComponentType = {}));
export var InputFieldMultilineAddressComponentType;
(function (InputFieldMultilineAddressComponentType) {
    InputFieldMultilineAddressComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    InputFieldMultilineAddressComponentType["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
})(InputFieldMultilineAddressComponentType || (InputFieldMultilineAddressComponentType = {}));
export var InputFieldInputType;
(function (InputFieldInputType) {
    InputFieldInputType["UNKNOWN_INPUT_TYPE"] = "UNKNOWN_INPUT_TYPE";
    InputFieldInputType["STRING"] = "STRING";
    InputFieldInputType["NUMBER"] = "NUMBER";
    InputFieldInputType["BOOLEAN"] = "BOOLEAN";
    InputFieldInputType["ARRAY"] = "ARRAY";
    InputFieldInputType["OBJECT"] = "OBJECT";
    InputFieldInputType["WIX_FILE"] = "WIX_FILE";
    InputFieldInputType["PAYMENT"] = "PAYMENT";
    InputFieldInputType["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
})(InputFieldInputType || (InputFieldInputType = {}));
export var FormFieldContactInfoEmailInfoTag;
(function (FormFieldContactInfoEmailInfoTag) {
    FormFieldContactInfoEmailInfoTag["UNTAGGED"] = "UNTAGGED";
    FormFieldContactInfoEmailInfoTag["MAIN"] = "MAIN";
})(FormFieldContactInfoEmailInfoTag || (FormFieldContactInfoEmailInfoTag = {}));
export var FormFieldContactInfoPhoneInfoTag;
(function (FormFieldContactInfoPhoneInfoTag) {
    FormFieldContactInfoPhoneInfoTag["UNTAGGED"] = "UNTAGGED";
    FormFieldContactInfoPhoneInfoTag["MAIN"] = "MAIN";
})(FormFieldContactInfoPhoneInfoTag || (FormFieldContactInfoPhoneInfoTag = {}));
export var AddressInfoTag;
(function (AddressInfoTag) {
    AddressInfoTag["UNTAGGED"] = "UNTAGGED";
    AddressInfoTag["HOME"] = "HOME";
})(AddressInfoTag || (AddressInfoTag = {}));
export var ConfirmationLevel;
(function (ConfirmationLevel) {
    ConfirmationLevel["UNKNOWN_CONFIRMATION_LEVEL"] = "UNKNOWN_CONFIRMATION_LEVEL";
    ConfirmationLevel["SINGLE_CONFIRMATION"] = "SINGLE_CONFIRMATION";
    ConfirmationLevel["DOUBLE_CONFIRMATION"] = "DOUBLE_CONFIRMATION";
})(ConfirmationLevel || (ConfirmationLevel = {}));
export var FormFieldContactInfoContactField;
(function (FormFieldContactInfoContactField) {
    FormFieldContactInfoContactField["UNKNOWN_CONTACT_FIELD"] = "UNKNOWN_CONTACT_FIELD";
    FormFieldContactInfoContactField["FIRST_NAME"] = "FIRST_NAME";
    FormFieldContactInfoContactField["LAST_NAME"] = "LAST_NAME";
    FormFieldContactInfoContactField["COMPANY"] = "COMPANY";
    FormFieldContactInfoContactField["POSITION"] = "POSITION";
    FormFieldContactInfoContactField["EMAIL"] = "EMAIL";
    FormFieldContactInfoContactField["PHONE"] = "PHONE";
    FormFieldContactInfoContactField["ADDRESS"] = "ADDRESS";
    FormFieldContactInfoContactField["BIRTHDATE"] = "BIRTHDATE";
    FormFieldContactInfoContactField["CUSTOM_FIELD"] = "CUSTOM_FIELD";
    FormFieldContactInfoContactField["SUBSCRIPTION"] = "SUBSCRIPTION";
    FormFieldContactInfoContactField["VAT_ID"] = "VAT_ID";
})(FormFieldContactInfoContactField || (FormFieldContactInfoContactField = {}));
export var DisplayFieldDisplayFieldType;
(function (DisplayFieldDisplayFieldType) {
    DisplayFieldDisplayFieldType["UNKNOWN_FIELD_TYPE"] = "UNKNOWN_FIELD_TYPE";
    DisplayFieldDisplayFieldType["RICH_CONTENT"] = "RICH_CONTENT";
    DisplayFieldDisplayFieldType["PAGE_NAVIGATION"] = "PAGE_NAVIGATION";
    DisplayFieldDisplayFieldType["LOGIN_BAR"] = "LOGIN_BAR";
})(DisplayFieldDisplayFieldType || (DisplayFieldDisplayFieldType = {}));
export var OverrideEntityType;
(function (OverrideEntityType) {
    OverrideEntityType["UNKNOWN"] = "UNKNOWN";
    OverrideEntityType["FIELD"] = "FIELD";
    OverrideEntityType["FORM"] = "FORM";
    OverrideEntityType["NESTED_FORM_FIELD"] = "NESTED_FORM_FIELD";
})(OverrideEntityType || (OverrideEntityType = {}));
export var Kind;
(function (Kind) {
    /** Return forms specific to tenant, excluding template based forms. */
    Kind["REGULAR"] = "REGULAR";
    /** Return forms based on common templates, with applied user overrides if they exist. */
    Kind["EXTENSION"] = "EXTENSION";
})(Kind || (Kind = {}));
export var SpamFilterProtectionLevel;
(function (SpamFilterProtectionLevel) {
    /** Unknown spam filter protection level. */
    SpamFilterProtectionLevel["UNKNOWN"] = "UNKNOWN";
    /** Spam filter is not used. Form is open for spam submissions. */
    SpamFilterProtectionLevel["NONE"] = "NONE";
    /** Spam filter operates in basic mode. Form is open to high risk of spam submissions. */
    SpamFilterProtectionLevel["BASIC"] = "BASIC";
    /** Spam filter operates in advanced mode. Form is open to low risk of spam submissions. */
    SpamFilterProtectionLevel["ADVANCED"] = "ADVANCED";
})(SpamFilterProtectionLevel || (SpamFilterProtectionLevel = {}));
export var UrlTargetEnumTarget;
(function (UrlTargetEnumTarget) {
    /** Unknown target. */
    UrlTargetEnumTarget["UNKNOWN_TARGET"] = "UNKNOWN_TARGET";
    /** Open in the same browser tab. */
    UrlTargetEnumTarget["SELF"] = "SELF";
    /** Open in a new browser tab. */
    UrlTargetEnumTarget["BLANK"] = "BLANK";
})(UrlTargetEnumTarget || (UrlTargetEnumTarget = {}));
export var SubmitSuccessAction;
(function (SubmitSuccessAction) {
    /** Unknown submit success action. */
    SubmitSuccessAction["UNKNOWN_SUBMIT_SUCCESS_ACTION"] = "UNKNOWN_SUBMIT_SUCCESS_ACTION";
    /** No action will be taken after submission. */
    SubmitSuccessAction["NO_ACTION"] = "NO_ACTION";
    /** A thank you message will be shown after submission. */
    SubmitSuccessAction["THANK_YOU_MESSAGE"] = "THANK_YOU_MESSAGE";
    /** The user will be redirected to a URL after submission. */
    SubmitSuccessAction["REDIRECT"] = "REDIRECT";
})(SubmitSuccessAction || (SubmitSuccessAction = {}));
/** Enum for different types of changeable properties. */
export var ChangeableProperty;
(function (ChangeableProperty) {
    /** Unknown property type. */
    ChangeableProperty["UNKNOWN_CHANGEABLE_PROPERTY"] = "UNKNOWN_CHANGEABLE_PROPERTY";
    /** Required property type. */
    ChangeableProperty["REQUIRED"] = "REQUIRED";
    /** Hidden property type. */
    ChangeableProperty["HIDDEN"] = "HIDDEN";
    /** Allowed values property type. */
    ChangeableProperty["ALLOWED_VALUES"] = "ALLOWED_VALUES";
})(ChangeableProperty || (ChangeableProperty = {}));
export var OverrideEntityTypeEnumOverrideEntityType;
(function (OverrideEntityTypeEnumOverrideEntityType) {
    OverrideEntityTypeEnumOverrideEntityType["UNKNOWN_OVERRIDE_ENTITY_TYPE"] = "UNKNOWN_OVERRIDE_ENTITY_TYPE";
    OverrideEntityTypeEnumOverrideEntityType["FIELD"] = "FIELD";
})(OverrideEntityTypeEnumOverrideEntityType || (OverrideEntityTypeEnumOverrideEntityType = {}));
export var Operator;
(function (Operator) {
    Operator["UNKNOWN_OPERATOR"] = "UNKNOWN_OPERATOR";
    Operator["EQUAL"] = "EQUAL";
    Operator["NOT_EQUAL"] = "NOT_EQUAL";
    Operator["EMPTY"] = "EMPTY";
    Operator["NOT_EMPTY"] = "NOT_EMPTY";
    Operator["CONTAINS"] = "CONTAINS";
    Operator["NOT_CONTAINS"] = "NOT_CONTAINS";
    Operator["LESS_THAN"] = "LESS_THAN";
    Operator["LESS_THAN_OR_EQUALS"] = "LESS_THAN_OR_EQUALS";
    Operator["GREATER_THAN"] = "GREATER_THAN";
    Operator["GREATER_THAN_OR_EQUALS"] = "GREATER_THAN_OR_EQUALS";
    Operator["BEFORE"] = "BEFORE";
    Operator["BEFORE_OR_EQUAL"] = "BEFORE_OR_EQUAL";
    Operator["AFTER"] = "AFTER";
    Operator["AFTER_OR_EQUAL"] = "AFTER_OR_EQUAL";
    Operator["BETWEEN"] = "BETWEEN";
    Operator["ANY"] = "ANY";
    Operator["ARRAY_EQUAL"] = "ARRAY_EQUAL";
    Operator["ARRAY_NOT_EQUAL"] = "ARRAY_NOT_EQUAL";
    Operator["CHECKED"] = "CHECKED";
    Operator["NOT_CHECKED"] = "NOT_CHECKED";
    Operator["IN"] = "IN";
    Operator["NOT_IN"] = "NOT_IN";
    Operator["IS_DATE_OLDER_THAN"] = "IS_DATE_OLDER_THAN";
    Operator["IS_DATE_OLDER_THAN_OR_EQUAL"] = "IS_DATE_OLDER_THAN_OR_EQUAL";
    Operator["IS_DATE_NEWER_THAN"] = "IS_DATE_NEWER_THAN";
    Operator["IS_DATE_NEWER_THAN_OR_EQUAL"] = "IS_DATE_NEWER_THAN_OR_EQUAL";
})(Operator || (Operator = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var Fieldset;
(function (Fieldset) {
    Fieldset["UNKNOWN"] = "UNKNOWN";
    /** Includes nested forms when present. */
    Fieldset["NESTED_FORMS"] = "NESTED_FORMS";
})(Fieldset || (Fieldset = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var CountFormsFieldset;
(function (CountFormsFieldset) {
    CountFormsFieldset["UNKNOWN"] = "UNKNOWN";
    /** Include deleted forms count. */
    CountFormsFieldset["DELETED"] = "DELETED";
})(CountFormsFieldset || (CountFormsFieldset = {}));
export var ListFormsOrderEnumListFormsOrder;
(function (ListFormsOrderEnumListFormsOrder) {
    /** Sorting by updated date descending. The default value. */
    ListFormsOrderEnumListFormsOrder["UPDATED_DATE_DESC"] = "UPDATED_DATE_DESC";
    /** Sorting by updated date ascending. */
    ListFormsOrderEnumListFormsOrder["UPDATED_DATE_ASC"] = "UPDATED_DATE_ASC";
    /** Sorting by created date ascending. */
    ListFormsOrderEnumListFormsOrder["CREATED_DATE_ASC"] = "CREATED_DATE_ASC";
    /** Sorting by created date descending. */
    ListFormsOrderEnumListFormsOrder["CREATED_DATE_DESC"] = "CREATED_DATE_DESC";
    /** Sorting by name ascending. */
    ListFormsOrderEnumListFormsOrder["NAME_ASC"] = "NAME_ASC";
    /** Sorting by name descending. */
    ListFormsOrderEnumListFormsOrder["NAME_DESC"] = "NAME_DESC";
})(ListFormsOrderEnumListFormsOrder || (ListFormsOrderEnumListFormsOrder = {}));
export var FilterType;
(function (FilterType) {
    FilterType["EXACT_MATCH"] = "EXACT_MATCH";
    FilterType["STARTS_WITH"] = "STARTS_WITH";
})(FilterType || (FilterType = {}));
export var ListFormsOrder;
(function (ListFormsOrder) {
    /** Sorting by updated date descending. The default value. */
    ListFormsOrder["UPDATED_DATE_DESC"] = "UPDATED_DATE_DESC";
    /** Sorting by updated date ascending. */
    ListFormsOrder["UPDATED_DATE_ASC"] = "UPDATED_DATE_ASC";
    /** Sorting by created date ascendingd. */
    ListFormsOrder["CREATED_DATE_ASC"] = "CREATED_DATE_ASC";
    /** Sorting by created date descending. */
    ListFormsOrder["CREATED_DATE_DESC"] = "CREATED_DATE_DESC";
    /** Sorting by name ascending. */
    ListFormsOrder["NAME_ASC"] = "NAME_ASC";
    /** Sorting by name descending. */
    ListFormsOrder["NAME_DESC"] = "NAME_DESC";
})(ListFormsOrder || (ListFormsOrder = {}));
export var ListDeletedFormsOrder;
(function (ListDeletedFormsOrder) {
    /** Sorting by updated date descending. The default value. */
    ListDeletedFormsOrder["UPDATED_DATE_DESC"] = "UPDATED_DATE_DESC";
    /** Sorting by updated date ascending. */
    ListDeletedFormsOrder["UPDATED_DATE_ASC"] = "UPDATED_DATE_ASC";
    /** Sorting by name descending. */
    ListDeletedFormsOrder["NAME_DESC"] = "NAME_DESC";
    /** Sorting by name ascending. */
    ListDeletedFormsOrder["NAME_ASC"] = "NAME_ASC";
})(ListDeletedFormsOrder || (ListDeletedFormsOrder = {}));
export var FieldInputType;
(function (FieldInputType) {
    FieldInputType["UNKNOWN_INPUT_TYPE"] = "UNKNOWN_INPUT_TYPE";
    FieldInputType["STRING"] = "STRING";
    FieldInputType["NUMBER"] = "NUMBER";
    FieldInputType["RATING"] = "RATING";
    FieldInputType["BOOLEAN"] = "BOOLEAN";
    FieldInputType["ARRAY"] = "ARRAY";
    FieldInputType["OBJECT"] = "OBJECT";
    FieldInputType["WIX_FILE"] = "WIX_FILE";
    FieldInputType["SIGNATURE"] = "SIGNATURE";
    FieldInputType["PAYMENT"] = "PAYMENT";
    FieldInputType["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
    FieldInputType["DATE"] = "DATE";
    FieldInputType["TIME"] = "TIME";
    FieldInputType["DATE_TIME"] = "DATE_TIME";
    FieldInputType["EMAIL"] = "EMAIL";
    FieldInputType["URL"] = "URL";
    FieldInputType["UUID"] = "UUID";
    FieldInputType["PHONE"] = "PHONE";
    FieldInputType["URI"] = "URI";
    FieldInputType["HOSTNAME"] = "HOSTNAME";
    FieldInputType["COLOR_HEX"] = "COLOR_HEX";
    FieldInputType["CURRENCY"] = "CURRENCY";
    FieldInputType["LANGUAGE"] = "LANGUAGE";
    FieldInputType["DATE_OPTIONAL_TIME"] = "DATE_OPTIONAL_TIME";
})(FieldInputType || (FieldInputType = {}));
//# sourceMappingURL=types.impl.js.map